/*
 * T-17-01 · FILTRADO Y DESCRIPCIÓN DE UNA CATEGORÍA EN EL SELECTOR CON BUSCADOR
 * (RF-230 a RF-234, RF-245, RN-652 a RN-657, RN-678; contrato de uso §2.2).
 *
 * ESTÁ ESCRITO AL LADO DE `filtradoDeCuentas.js` A PROPÓSITO (RN-651): son las
 * DOS mitades de datos del mismo control. Aquí no hay JSX, no hay estado, no hay
 * teclado y no hay red: solo datos y funciones puras. Si algo de esto necesitara
 * comportamiento, el sitio donde se amplía es EL CONTROL, una vez, para todos
 * los perfiles (RN-658).
 *
 * LO QUE ESTE MÓDULO NO HACE, y es contrato:
 *   · NO recorta por tipo ni por activa (RN-653): la lista llega YA FILTRADA POR
 *     EL SERVIDOR según la pantalla —GASTO o INGRESO y solo activas en las
 *     capturas; ambos tipos y `soloActivas: false` en el filtro del historial—.
 *   · NO conoce la idea de «todas las categorías» (RN-680, D-369): toda opción es
 *     una categoría del catálogo. El estado «sin filtro» es el VALOR VACÍO y vive
 *     en el consumidor (RN-677).
 *   · NO mira `claveSiembra` (RN-656): no se muestra, no se busca y no viaja
 *     distinto. El aviso de «Reembolsos» lo decide el servidor después de guardar.
 */

import { normalizar } from './filtradoDeCuentas.js';

/**
 * Filtra por coincidencia PARCIAL EN CUALQUIER POSICIÓN contra el NOMBRE de la
 * categoría, con la misma normalización del proyecto: sin mayúsculas, sin acentos
 * y colapsando espacios (RN-652). Escribir `super` encuentra «Supermercado»;
 * escribir `medico` encuentra «Médico y dentista».
 *
 * EL SUFIJO « · desactivada» NO PARTICIPA DE LA BÚSQUEDA (RN-678): teclear
 * `desactivada` no encuentra nada, porque esa palabra no está en ningún nombre.
 *
 * Con el texto vacío devuelve la lista completa y en su orden: el orden lo
 * resolvió el servidor y el cliente no reordena.
 */
export function filtrarCategorias(categorias, texto) {
  const buscado = normalizar(texto);
  if (!buscado) return [...(categorias ?? [])];
  return (categorias ?? []).filter((categoria) => normalizar(categoria?.nombre).includes(buscado));
}

/**
 * Lo que se ve en el renglón: EL NOMBRE, Y NADA MÁS (RF-232). No se añade color,
 * icono, tipo ni clave: lo que el desplegable nativo mostraba era el nombre y eso
 * se conserva.
 *
 * ÚNICA EXCEPCIÓN, y es dato, no comportamiento (RN-678): una categoría que llega
 * DESACTIVADA se describe «nombre · desactivada». Eso solo ocurre en el filtro del
 * historial, que pide el catálogo con `soloActivas: false` porque filtra sobre todo
 * lo que existió; en las capturas esta rama NUNCA se ejecuta, porque ahí el
 * servidor manda solo activas.
 */
export function describirCategoria(categoria) {
  const nombre = categoria?.nombre ?? '';
  return categoria?.activo === false ? `${nombre} · desactivada` : nombre;
}

/** Lo mismo para el lector de pantalla (RNF-121). */
export function describirCategoriaParaLector(categoria) {
  const nombre = categoria?.nombre ?? '';
  return categoria?.activo === false ? `${nombre}, categoría desactivada` : nombre;
}

/** El número de coincidencias, con el sustantivo categoría (RN-654). */
export function anunciarCategoriasCoincidentes(cantidad) {
  if (cantidad === 0) return 'Ninguna categoría coincide';
  return cantidad === 1 ? '1 categoría coincide' : `${cantidad} categorías coinciden`;
}
